// Templates et campagnes WhatsApp (SP4) : libellés, statuts et aperçu partagés par les pages pikachu.

export const VARIABLES = [
    { key: "prenom", label: "prénom", example: "Léa" },
    { key: "produit", label: "produit", example: "Nike Pegasus 41 Homme" },
    { key: "prix", label: "prix", example: "89,90 €" },
    { key: "pointure", label: "pointure", example: "42" },
];

export const PRODUCT_VARIABLES = ["produit", "prix", "pointure"];

const STATUS = {
    draft: { label: "Brouillon", color: "#555", bg: "#f1f1f1" },
    pending: { label: "En attente Meta", color: "#9a5b00", bg: "#fff4e0" },
    approved: { label: "Approuvé", color: "#167a43", bg: "#eaf6ef" },
    rejected: { label: "Refusé", color: "#a50e15", bg: "#fdecec" },
    paused: { label: "En pause (Meta)", color: "#a50e15", bg: "#fdecec" },
    disabled: { label: "Désactivé", color: "#a50e15", bg: "#fdecec" },
};

export function statusBadge(status) {
    return STATUS[status] || { label: status || "—", color: "#555", bg: "#f1f1f1" };
}

const CAMPAIGN_STATUS = {
    draft: { label: "Brouillon", color: "#555", bg: "#f1f1f1" },
    scheduled: { label: "Programmée", color: "#3346a8", bg: "#eef2ff" },
    sending: { label: "En cours d'envoi", color: "#9a5b00", bg: "#fff4e0" },
    paused: { label: "En pause", color: "#9a5b00", bg: "#fff4e0" },
    done: { label: "Terminée", color: "#167a43", bg: "#eaf6ef" },
    cancelled: { label: "Annulée", color: "#555", bg: "#f1f1f1" },
    failed: { label: "Échec", color: "#a50e15", bg: "#fdecec" },
};

export function campaignBadge(status) {
    return CAMPAIGN_STATUS[status] || { label: status || "—", color: "#555", bg: "#f1f1f1" };
}

export const SOURCES = {
    alert: "Alertes ouvertes",
    favorite: "Favoris",
    conversation: "Conversation",
    fallback: "Repli (meilleure promo dans sa pointure)",
    "": "Message identique pour tous",
};

// variables du message, dans l'ordre d'apparition
export function templateVariables(body) {
    const out = [];
    (body || "").replace(/\{\{([a-z_]+)\}\}/g, (_, v) => { if (!out.includes(v)) out.push(v); return ""; });
    return out;
}

export function isPersonalized(t) {
    if (!t) return false;
    return t.header === "product_image" || templateVariables(t.body).some((v) => PRODUCT_VARIABLES.includes(v))
        || (t.buttons || []).some((b) => b.kind === "product_url");
}

// aperçu : variables remplacées par les exemples (ou valeurs fournies)
export function renderPreview(body, values = {}) {
    return (body || "").replace(/\{\{([a-z_]+)\}\}/g, (_, v) => values[v] || (VARIABLES.find((x) => x.key === v) || {}).example || `{{${v}}}`);
}

export const fmtDate = (d) => {
    const date = new Date(d);
    return isNaN(date.getTime()) || date.getFullYear() < 1971 ? "—" : date.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
};

export async function readError(res) {
    try {
        const body = await res.json();
        return body.message || body.error || JSON.stringify(body);
    } catch {
        return "HTTP " + res.status;
    }
}
